import { RestrictedEditingMode } from 'pleditor';
import { useCompanyFeatures } from 'app/domains/companies';
import { useDocumentLocked } from 'app/domains/documents';
import { useGetCurrentUser } from 'shared/domains/documents';
import { PleditorError } from '../../components/PleditorError';
import { PleditorLoader } from '../../components/PleditorLoader';
import { useGetUserIdAccess } from '../../hooks/useGetUsersAccess';
import { RTCPleditor } from '../RTCPleditor';
import { useImportDocumentToCcs, useGetDocumentFeatures } from '../hooks';
import { APP_FREE_TEXT_PLUGINS } from '../plugins';
export function AppFreeTextRTCPleditor() {
    const { locked } = useDocumentLocked();
    const currentUser = useGetCurrentUser();
    const { usersExternal, usersWithoutAccess, usersWithAccess } = useGetUserIdAccess();
    const { loading: importing, error: importError } = useImportDocumentToCcs();
    const { documentFeatures, loading: loadingFeatures, error: featuresError, } = useGetDocumentFeatures();
    const { isFeatureAvailable } = useCompanyFeatures();
    const isDocumentAssistantAvailable = isFeatureAvailable('document-assistant:basic');
    const loading = importing || loadingFeatures;
    const error = importError || featuresError;
    const plugins = locked
        ? [...APP_FREE_TEXT_PLUGINS, RestrictedEditingMode]
        : APP_FREE_TEXT_PLUGINS;
    if (loading) {
        return <PleditorLoader />;
    }
    if (error) {
        return <PleditorError />;
    }
    const toolbarItems = [
        'undo',
        'redo',
        '|',
        'heading',
        '|',
        'bold',
        'italic',
        'strikethrough',
        'underline',
        'bulletedList',
        'numberedList',
        '|',
        'link',
        'alignment',
        'outdent',
        'indent',
        '<->',
        'inlineComment',
        '|',
        'customCommentsArchive',
        '|',
        'revisionHistory',
        '|',
        'toggleComments',
        '|',
        'editMode',
        'importWord',
    ];
    const balloonToolbarItems = isDocumentAssistantAvailable
        ? ['inlineCommentCompact', '|', 'bold', 'italic', 'underline', '|', 'inlineAssistantShortcut']
        : ['inlineCommentCompact', '|', 'bold', 'italic', 'underline'];
    return (<RTCPleditor documentType="freetext" toolbarItems={toolbarItems} balloonToolbarItems={balloonToolbarItems} currentUser={currentUser} featureAvailability={documentFeatures} usersExternal={usersExternal} usersWithAccess={usersWithAccess} usersWithoutAccess={usersWithoutAccess} plugins={plugins} locked={locked}/>);
}
